import { createFileRoute } from '@tanstack/react-router';
import { OfficesModule } from '@/modules/offices';

export const Route = createFileRoute('/(dashboard)/_dashboard/master-data/office')({
  component: OfficesModule,
});
